import { defineMessage } from 'services/localization';

export const messages = {
    addButtonText: defineMessage('add'),
    deleteButtonText: defineMessage('delete'),
    captureButtonText: defineMessage('capture'),
    downloadButtonText: defineMessage('download'),
    goToPrevDocumentButtonText: defineMessage('go_to_previous_attachment'),
    goToNextDocument: defineMessage('go_to_next_attachment'),
    deleteFileDescription: defineMessage('delete_file'),
    yesDeleteButtonText: defineMessage('yes'),
    noDeleteButtonText: defineMessage('no'),
};
